import React from 'react';
import './index.scss';

const AdsLoadingIndicator = () => (
  <div className="ads-loaing-indicator df aic jcsa">
    <i className=" dib" />
  </div>
);
export default AdsLoadingIndicator;
